// StartTimeRange should be equal to OB content-api's TimeRange enum (you can find it in OB documentation)
export enum StartTimeRange {
    Live = "LIVE",
    Today = "TODAY",
    OneHour = "ONE_HOUR",
    ThreeHours = "THREE_HOURS",
    SixHours = "SIX_HOURS",
    TwelveHours = "TWELVE_HOURS",
    Tomorrow = "TOMORROW",
    OneDay = "ONE_DAY",
    TwoDays = "TWO_DAYS",
    OneWeek = "ONE_WEEK",
    Future = "FUTURE",
}
